import { useQuery } from '@tanstack/react-query';
import { companyService } from '../services/company.service';
import type { Company, ListCompaniesParams } from '../types/company.types';

export function useCompanies(params: ListCompaniesParams = {}): {
  companies: Company[];
  hasData: boolean;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  refetch: () => void;
} {
  const query = useQuery({
    queryKey: ['companies', params],
    queryFn: () => companyService.listCompanies(params),
  });

  return {
    companies: query.data ?? [],
    hasData: query.data !== undefined,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
